import React from 'react';
import PropTypes from 'prop-types';
import DatePickerField from '@/modules/common/components/DatePickerField';
import '../styles/DateRangeField.scss';

const DateRangeField = (props) => {
    return (
        <div className="date-range">
            <DatePickerField label={props.label.from} value={props.value.from}
                        setValue={(value) => props.setValue({...props.value, from: value})}
                        error={props.errors.from.length > 0}
                        helperText={props.errors.from}
                        onFocus={props.onFocus.from}
            />
            <DatePickerField label={props.label.to} value={props.value.to}
                        setValue={(value) => props.setValue({...props.value, to: value})}
                        error={props.errors.to.length > 0}
                        helperText={props.errors.to}
                        onFocus={props.onFocus.to}
            />
        </div>
    );
};

DateRangeField.propTypes = {
    label: PropTypes.object,
    value: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired,
    errors: PropTypes.object,
    onFocus: PropTypes.object,
};

DateRangeField.defaultProps = {
    label: {from: 'с', to: 'по'},
    errors: {from: '', to: ''},
    onFocus: {from: undefined, to: undefined},
};

export default DateRangeField;
